export default {
  uploading: 'Subiendo',
  cancel: 'Cancelar',
  editTitle: 'Editar Modelo Ad-Hoc',
  newTitle: 'Nuevo Modelo Ad-Hoc',
  save: 'Guardar',
  create: 'Crear',
  modelCodename: 'Código del Modelo',
  modelName: 'Nombre del Modelo',
  json: 'JSON',
  stages: 'Etapas',
  settings: 'Configuración',
  enableDataUploader: 'Habilitar Carga de Datos',
  slackChannel: 'Canal de Slack',
  enableAISummary: 'Habilitar Resumen de IA',
  impressionsModel: 'Modelo de Impresiones',
  useDifferentConfigForPlans: 'Usar configuración/PKL diferente para planes',
  modelReportPkl: 'PKL del Reporte del Modelo',
  modelPkl: 'PKL del Modelo',
  downloadModelReportPkl: 'Descargar archivo PKL del Reporte del Modelo actual',
  downloadPkl: 'Descargar archivo PKL actual',
  noPklAvailable: 'No hay archivo PKL disponible para este modelo',
  choosePklFile: 'Elegir archivo PKL para subir',
  pklRequired: 'El archivo PKL es requerido',
  plansConfiguration: 'Configuración de Planes',
  plansJson: 'JSON de Planes',
  plansJsonRequired: 'El JSON de Planes es requerido cuando se usa configuración/PKL diferente para planes',
  downloadPlansPkl: 'Descargar archivo PKL de Planes actual',
  plansPkl: 'PKL de Planes',
  noPlansPklAvailable: 'No hay archivo PKL de Planes disponible para este modelo',
  choosePlansPklFile: 'Elegir archivo PKL de Planes para subir',
  plansPklRequired: 'El archivo PKL de Planes es requerido cuando se usa configuración/PKL diferente para planes',
  codenameRequired: 'El código es requerido',
  codenameInvalid: 'El código solo puede contener caracteres alfanuméricos, "-" o "_"',
  codenameExists: 'El código ya existe',
  nameRequired: 'El nombre es requerido',
  invalidJson: 'JSON inválido',
  invalidPlansJson: 'JSON de Planes inválido',
  version: 'Versión',
  optimizerGpu: 'GPU del Plan Optimizer',
  optimizerGpuHint: 'GPU de los servidores que ejecutan los planes del Plan Optimizer de este modelo. El Plan Calculator, el Budget Simulator y los reportes del modelo siempre usan una T4.',
  gpuT4: '1× T4 (predeterminada)',
  gpuA100: '1× A100 40GB',
  uploadFailedCreate: 'No se pudo subir el archivo {file}, así que el modelo no se creó. Revisa tu conexión y vuelve a intentarlo. ({error})',
  uploadFailedEdit: 'No se pudo subir el archivo {file}, así que los cambios no se guardaron. Revisa tu conexión y vuelve a intentarlo. ({error})'
}
